function t(e) {
  return (t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(e);
}

function e(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}

function r(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}

function n(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
    var r = [],
        n = !0,
        o = !1,
        a = void 0;

    try {
      for (var i, u = t[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0) {
        ;
      }
    } catch (t) {
      o = !0, a = t;
    } finally {
      try {
        n || null == u.return || u.return();
      } finally {
        if (o) throw a;
      }
    }

    return r;
  }(t, e) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return o(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === r && t.constructor && (r = t.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(t);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(t, e);
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function o(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }

  return n;
}

var a = function () {
  function t(e) {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t), r(this, "value", 0), r(this, "prefix", void 0), this.prefix = e;
  }

  var o, a, i;
  return o = t, i = [{
    key: "create",
    value: function value(e) {
      var r,
          n = null !== (r = this.registry.get(e)) && void 0 !== r ? r : new t(e);
      return t.registry.set(e, n), n;
    }
  }, {
    key: "snapshot",
    value: function value() {
      var t = {};
      return this.registry.forEach(function (e) {
        t[e.prefix] = e.value;
      }), t;
    }
  }, {
    key: "restore",
    value: function value(t) {
      var e = this;
      this.registry.forEach(function (e) {
        t && e.prefix in t || (e.value = 0);
      }), t && Object.entries(t).forEach(function (t) {
        var r,
            o = n(t, 2),
            a = o[0],
            i = o[1];
        (null !== (r = e.registry.get(a)) && void 0 !== r ? r : e.create(a)).value = i;
      });
    }
  }], (a = [{
    key: "generate",
    value: function value() {
      return "".concat(this.prefix, "-").concat(this.value++);
    }
  }]) && e(o.prototype, a), i && e(o, i), t;
}();

function i(t) {
  return null != t && t.nodeType === Node.ELEMENT_NODE;
}

r(a, "registry", new Map());
var u = Object.freeze({
  __proto__: null,
  element: i,
  button: function button(t) {
    return i(t) && "button" === t.tagName.toLowerCase();
  },
  input: function input(t) {
    return i(t) && "input" === t.tagName.toLowerCase();
  },
  array: function array(t) {
    return null != t && t instanceof Array;
  }
});

function c(e, r) {
  return null != e && "object" === t(e) && "type" in e && e.type.displayName === r;
}

function l(t) {
  var e = "data-leafygreen-ui";
  return {
    prop: r({}, e, t),
    selector: "[".concat(e, '="').concat(t, '"]')
  };
}

var f = {
  ArrowUp: 38,
  ArrowDown: 40,
  ArrowLeft: 37,
  ArrowRight: 39,
  Enter: 13,
  Escape: 27,
  Space: 32,
  Tab: 9
},
    y = {
  Page: "page",
  Step: "step",
  Location: "location",
  Date: "date",
  Time: "time",
  True: "true",
  Unset: "false"
};

function s(t) {
  throw Error("Received unhandled value: ".concat(t));
}

export { y as AriaCurrentValue, a as IdAllocator, l as createDataProp, s as enforceExhaustive, c as isComponentType, f as keyMap, u as typeIs };